<template>
  <div
    class="edit-select-audio"
    :class="{
      [`edit-select-audio--${createRenderType}`]: true,
    }"
  >
    <div class="edit-select-audio-select-area-box flex">
      <div class="edit-select-audio-select-area-time width-0 flex1">
        {{
          `${mediaUtil.formatTime(
            renderData.duration * renderData.progress > 0
              ? renderData.duration * renderData.progress
              : 0
          )} / ${mediaUtil.formatTime(renderData.duration)}`
        }}
      </div>
      <div class="edit-select-audio-select-close" v-if="!props.hideRemove">
        <IconButton
          size="32px"
          icoSize="20px"
          @onClick="onRemoveClick"
          backgroundColor="rgba(255, 255, 255, 0.1)"
          hoverBackgroundColor="rgba(255, 255, 255, 0.2)"
        >
          <img src="@/assets/img/editor/delete-remove-ico.png" />
        </IconButton>
      </div>
    </div>
    <div class="edit-select-audio-select-area-edit-box">
      <RenderClipSelectDuration
        v-if="renderData.ifRenderClippingSelectDuration"
        ref="refClippingSelectDuration"
        :config="props.config"
        :type="props.type"
        :url="props.url"
        :duration="renderData.duration"
        :formatTime="props.type == 'select' ? null : formatTime"
        :waveformData="props.waveformData"
        @syncSelectData="doSyncSelectData"
        @syncProgress="doSyncProgress"
        @selectDataChange="doSelectDataChange"
        @selectChangeLimit="doSelectChangeLimit"
      />
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";

import { useRouter, useRoute } from "vue-router";

import IconButton from "@/components/basic/button/IconButton.vue";
import ClippingSelectDuration from "@/components/media/clip/ClippingSelectDuration.vue";
import ClipForwardSelectDurarion from "@/components/media/clip/ClipForwardSelectDurarion.vue";

import mediaUtil from "@/components/media/utils/utils.js";
import { $$language, $$t, $$tValue } from "@/i18n/i18n.js";

import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);

const Router = useRouter();
const route = useRoute();

const props = defineProps({
  config: {
    type: Object,
    default: null,
  },
  type: {
    type: String,
    default: "select", // "extendSelect"
  },
  hideRemove: {
    type: Boolean,
    default: false,
  },
  url: {
    type: String,
    default: "",
  },
  duration: {
    type: Number,
    default: 0,
  },
  waveformData: {
    type: Object,
    default: null,
  },
});
const RenderClipSelectDuration =
  props.type === "extendSelect"
    ? ClipForwardSelectDurarion
    : ClippingSelectDuration;

const emits = defineEmits(["syncSelectData", "selectChangeLimit"]);

const refClippingSelectDuration = ref(null);

const formatTime = (time) => {
  return $$tValue("editor.extend_from_time", {
    time: mediaUtil.formatTimeMs(time),
  });
};

const renderData = reactive({
  startTime: "00:00",
  progress: 0,
  from: 0,
  to: 0,
  duration: 0,
  ifRenderClippingSelectDuration: true,
});

const doSyncProgress = (progress, startTime) => {
  renderData.progress = progress;
  renderData.startTime = startTime;
};
const doSyncDuration = (duration) => {
  renderData.duration = duration;
};

const doSyncSelectData = (data) => {
  renderData.from = data.from;
  renderData.to = data.to;
  renderData.duration = data.duration;
  emits("syncSelectData", data);
};

const doSelectDataChange = (data) => {
  renderData.from = data.from;
  renderData.to = data.to;
  renderData.duration = data.duration;
  emits("syncSelectData", data);
};

const doSelectChangeLimit = (data) => {
  console.log("🍎🍎🍎🍎doSelectChangeLimit", data);
  emits("selectChangeLimit", data);
};

const onRemoveClick = () => {
  emits("remove");
};

onMounted(() => {
  renderData.duration = props.duration;

  // renderData.resizeObserver = new ResizeObserver(() => {
  //   renderData.ifRenderClippingSelectDuration = false;
  //   nextTick(() => {
  //     renderData.ifRenderClippingSelectDuration = true;
  //   });
  // });

  // renderData.resizeObserver?.observe(document.body);
});

onUnmounted(() => {
  // renderData.resizeObserver?.disconnect();
});

defineExpose({
  getSelectData: () => {
    return {
      from: renderData.from,
      to: renderData.to,
      selecDuration: renderData.to - renderData.from,
      duration: renderData.duration,
    };
  },
  setSelectData: (data) => {
    if (props.type === "extendSelect") {
      refClippingSelectDuration.value?.setRenerateStartTime(data.from);
    } else {
      refClippingSelectDuration.value?.setRenerateSelectTime(data);
    }
  },
});

watch(
  () => {
    return props.duration;
  },
  () => {
    renderData.duration = props.duration;
  }
);
</script>
<style lang="scss">
.edit-select-audio {
  padding: 11px 0 8px;
  .edit-select-audio-select-area-box {
    display: flex;
    align-items: center;
    padding: 0 6px 0 14px;
  }
  .edit-select-audio-select-area-time {
    font-size: 14px;
    font-weight: normal;
    line-height: 36px;
    color: #ffffff;
  }
  .clipping-forward-select-duration-edit {
    padding: 8px 0 0 0;
  }
  .clipping-select-duration-edit {
    padding: 8px 0 0 0;
  }
  .edit-select-audio-select-close {
    padding: 0 6px 0 0;
  }
  &.edit-select-audio--mobile {
    padding: 9px 0 12px 0;
    .edit-select-audio-select-area-edit-box {
      .clipping-select-duration-edit {
        padding: 8px 0 0 0;
      }
    }
    .edit-select-audio-select-area-time {
      padding: 0 0 0 0;
    }
    .edit-select-audio-select-close {
      padding: 0 6px 0 0;
    }
  }
}
</style>
